const LOCAL_WEB_HOSTS = new Set(["localhost", "127.0.0.1"]);

function getLocalApiBaseUrl(hostname?: string): string {
  const resolvedHostname = hostname && LOCAL_WEB_HOSTS.has(hostname) ? hostname : "localhost";
  return `http://${resolvedHostname}:3000`;
}

export function resolveApiBaseUrl({
  configuredApiUrl,
  hostname,
}: {
  configuredApiUrl?: string;
  hostname?: string;
}): string {
  if (configuredApiUrl) {
    return configuredApiUrl;
  }

  if (hostname && LOCAL_WEB_HOSTS.has(hostname)) {
    return getLocalApiBaseUrl(hostname);
  }

  return getLocalApiBaseUrl();
}

export function getApiBaseUrl(): string {
  const configuredApiUrl = import.meta.env.VITE_API_URL;

  if (typeof window === "undefined") {
    return resolveApiBaseUrl({ configuredApiUrl });
  }

  return resolveApiBaseUrl({
    configuredApiUrl,
    hostname: window.location.hostname,
  });
}
